import React from "react";
import styles from './styles.module.scss';

export default function Tooltip({children, iconSrc, width}) {
    return (
        <div className={styles.tooltip}>
            <div className={styles['tooltip__icon']}>
                {
                    iconSrc
                        ? <img src={iconSrc} alt="tooltip icon" />
                        : '?'
                }
            </div>
            <p
                className={styles['tooltip__text']}
                style={{width}}
            >
                {children}
            </p>
        </div>
    );
};
